var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46002 11.29L14.12 5.64004C14.213 5.54631 14.3236 5.47191 14.4454 5.42115C14.5673 5.37038 14.698 5.34424 14.83 5.34424C14.962 5.34424 15.0927 5.37038 15.2146 5.42115C15.3365 5.47191 15.4471 5.54631 15.54 5.64004C15.7263 5.8274 15.8308 6.08085 15.8308 6.34504C15.8308 6.60922 15.7263 6.86267 15.54 7.05004L10.59 12.05L15.54 17C15.7263 17.1874 15.8308 17.4409 15.8308 17.705C15.8308 17.9692 15.7263 18.2227 15.54 18.41C15.4474 18.5045 15.337 18.5797 15.2151 18.6312C15.0932 18.6827 14.9623 18.7095 14.83 18.71C14.6977 18.7095 14.5668 18.6827 14.445 18.6312C14.3231 18.5797 14.2126 18.5045 14.12 18.41L8.46002 12.76C8.35851 12.6664 8.2775 12.5527 8.2221 12.4262C8.16669 12.2997 8.13809 12.1631 8.13809 12.025C8.13809 11.8869 8.16669 11.7503 8.2221 11.6238C8.2775 11.4973 8.35851 11.3837 8.46002 11.29Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.cc2a5d14916f18b1c2f866370f5591be.svg";
export { ForwardRef as ReactComponent };